import { Grid, Typography } from '@mui/material';
import { Container } from '@mui/system';
import { footerTimeLineObj } from 'assets/animation/portalAnimation';
import images from 'assets/images';
import React from 'react';
import { useSelector } from 'react-redux';
import ModalForm from 'shared/ModalForm';
import { IApplicationState } from 'store/state/app-state';
import { ISystemSettingModel } from 'models/setting';
import TermsAndConditions from './TermsAndConditions';

const Footer: React.FC = () => {
    const footerTimeLine = React.useRef(null);
    const setting: ISystemSettingModel = useSelector((state: IApplicationState) => state?.Setting);
    const currentYear = new Date()?.getFullYear();

    const [openConditionModal, setOpenConditionModal] = React.useState(false);
    const [openPolicyModal, setOpenPolicyModal] = React.useState(false);

    React.useEffect(() => {
        footerTimeLineObj(footerTimeLine);
    }, []);

    const handleOpenConditionModal = () => setOpenConditionModal(true);
    const handleCloseConditionModal = () => setOpenConditionModal(false);

    const handleOpenPolicyModal = () => setOpenPolicyModal(true);
    const handleClosePolicyModal = () => setOpenPolicyModal(false);

    return (
        <>
            <footer className="footer" ref={footerTimeLine}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <div className="portal-info">
                                <div className="logo-block">
                                    <img src={images.logoWhiteIcon} alt="Logo" />
                                </div>
                                <div className="portal-links">
                                    {setting?.contacT_US_EMAIL && (
                                        <a href={`mailto:${setting?.contacT_US_EMAIL}`}>
                                            <img src={images.mailIcon} alt="Mail Icon" />
                                            {setting?.contacT_US_EMAIL}
                                        </a>
                                    )}
                                    {setting?.healthreacH_CONTACT_PHONE_NUMBER && (
                                        <a href={`tel:${setting?.healthreacH_CONTACT_PHONE_NUMBER}`}>
                                            <img src={images.phoneIcon} alt="Phone Icon" />
                                            {setting?.healthreacH_CONTACT_PHONE_NUMBER}
                                        </a>
                                    )}
                                    <p style={{ maxWidth: 'none' }}>
                                        <span>
                                            <img src={images.locationIcon} alt="Location Icon" />
                                        </span>
                                        {setting?.healthreacH_CONTACT_ADDRESS
                                            ? setting?.healthreacH_CONTACT_ADDRESS
                                            : ''}
                                        <br />
                                        {` ${
                                            setting?.healthreacH_CONTACT_SUBURB
                                                ? setting?.healthreacH_CONTACT_SUBURB
                                                : ''
                                        } ${
                                            setting?.healthreacH_CONTACT_STATE ? setting?.healthreacH_CONTACT_STATE : ''
                                        } ${
                                            setting?.healthreacH_CONTACT_POSTALCODE
                                                ? `${setting?.healthreacH_CONTACT_POSTALCODE},`
                                                : ''
                                        } ${
                                            setting?.healthreacH_CONTACT_COUNTRY
                                                ? setting?.healthreacH_CONTACT_COUNTRY
                                                : ''
                                        }`}
                                        {/* 98 Bundock St Belgian Gardens QLD 4810 */}
                                    </p>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <div className="link-wrapper">
                                <div className="social-links">
                                    {setting?.facebooK_LINK && (
                                        <a
                                            href={setting?.facebooK_LINK}
                                            target="_blank"
                                            rel="noreferrer"
                                            title="Facebook"
                                        >
                                            <img src={images.facebookIcon} alt="Icon" />
                                        </a>
                                    )}
                                    {setting?.twitteR_LINK && (
                                        <a
                                            href={setting?.twitteR_LINK}
                                            target="_blank"
                                            rel="noreferrer"
                                            title="Twitter"
                                        >
                                            <img src={images.twitterIcon} alt="Icon" />
                                        </a>
                                    )}
                                    {setting?.instagraM_LINK && (
                                        <a
                                            href={setting?.instagraM_LINK}
                                            target="_blank"
                                            rel="noreferrer"
                                            title="Instagram"
                                        >
                                            <img src={images.instagramIcon} alt="Icon" />
                                        </a>
                                    )}
                                    {setting?.linkediN_LINK && (
                                        <a
                                            href={setting?.linkediN_LINK}
                                            target="_blank"
                                            rel="noreferrer"
                                            title="Linkedin"
                                        >
                                            <img src={images.linkdnIcon} alt="Icon" />
                                        </a>
                                    )}
                                    {setting?.youtubE_LINK && (
                                        <a
                                            href={setting?.youtubE_LINK}
                                            target="_blank"
                                            rel="noreferrer"
                                            title="Youtube"
                                        >
                                            <img src={images.youtubeIcon} alt="Icon" />
                                        </a>
                                    )}
                                </div>
                                <div className="conditions">
                                    <p>All Rights Reserved</p>{' '}
                                    {setting?.termS_AND_CONDITION_CONTENT && (
                                        <>
                                            <span>|</span>
                                            <a onClick={handleOpenConditionModal}>Terms and Conditions</a>
                                        </>
                                    )}
                                    {setting?.privacY_POLICY_CONTENT && (
                                        <>
                                            <span>|</span>
                                            <a onClick={handleOpenPolicyModal}>Privacy Policy</a>{' '}
                                        </>
                                    )}
                                </div>
                                <div className="copyright-wrapper">
                                    <p className="copyright">
                                        Copyright © {currentYear} Healthreach <em>TM</em>
                                    </p>
                                    <span>
                                        Powered by&nbsp;
                                        <a href={setting?.tatvasofT_LINK} target="_blank" rel="noreferrer">
                                            TatvaSoft
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </footer>
            <ModalForm
                openModal={openConditionModal}
                title="Healthreach Website Terms and Conditions of Use"
                handleModalClose={handleCloseConditionModal}
                bodyContent={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: setting?.termS_AND_CONDITION_CONTENT,
                        }}
                    />
                }
            />
            <ModalForm
                openModal={openPolicyModal}
                title="Privacy Policy"
                handleModalClose={handleClosePolicyModal}
                bodyContent={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: setting?.privacY_POLICY_CONTENT,
                        }}
                    />
                }
            />
        </>
    );
};

export default Footer;
